import { ActionTypes } from './action-types.enum';

const initialState = {
  groups: [],
  lastUsedGroupId: '',
};

const renameGroup = (state, action) => {
  const { groups } = state;
  const group = groups.find((el) => el.id === action.payload?.data.groupId);
  const groupIndex = groups
    .findIndex((el) => el.id === action.payload?.data.groupId);
  groups[groupIndex] = {
    ...group,
    title: action.payload?.data.title,
  };
  return {
    ...state,
    groups,
  };
};

const setLastUsedGroup = (state, action) => {
  const { groups } = state;
  let id = false;

  if (action.payload?.groupId) {
    id = action.payload.groupId;
  }

  if (!id && !state.lastUsedGroupId) {
    id = groups[0] ? groups[0].id : '';
  }

  return {
    ...state,
    lastUsedGroupId: id || state.lastUsedGroupId,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_GROUPS:
      if (!state.lastUsedGroupId && action.payload?.groups) {
        return {
          ...state,
          groups: action.payload.groups,
          lastUsedGroupId: action.payload?.groups[0].id,
        };
      }

      return {
        ...state,
        groups: action.payload?.groups || [],
      };
    case ActionTypes.RENAME_GROUP:
      return renameGroup(state, action);
    case ActionTypes.ADD_GROUP:
      return {
        ...state,
        groups: [action.payload?.group, ...state.groups],
      };
    case ActionTypes.SET_LAST_USED_GROUP:
      return setLastUsedGroup(state, action);
    case ActionTypes.DELETE_GROUP:
      return {
        ...state,
        groups: state.groups?.filter((el) => el.id !== action.payload?.id),
      };
    default:
      return state;
  }
};
